/* istanbul ignore file */

export const ARRIVE_ON_OR_BEFORE = 'Estimated to arrive on or before';
export const YOUR_DATE = 'your date';
export const SHOW_MORE_DATES = 'Show more dates';
export const SHOW_FEWER_DATES = 'Show less';
